<template>
  <div class="details">
    <QS-scroller-box>
      <div class="details_content_title">
        <QS-h3-title class="purchase" title="服务商审批详情"></QS-h3-title>
      </div>

      <detail-base-info
        labelWidth="130"
        title="服务商信息"
        :source="baseInfo"
        :list="baseInfoList"
      >
        <template>
          <div class="column_content_mrbtm">
            <div class="column-title">合同附件:</div>
            <div v-if="baseInfo.fileUrls.length > 0">
              <el-image
                v-for="(itemSrc, index) in baseInfo.fileUrls"
                :key="index"
                style="width: 100px; height: 100px; margin-left: 5px"
                :src="itemSrc"
                fit="fit"
              ></el-image>
            </div>
          </div>
        </template>
      </detail-base-info>

      <detail-base-info
        labelWidth="130"
        title="审核信息"
        :source="examineInfo"
        :list="examineList"
      />
    </QS-scroller-box>
    <div class="btns">
      <el-button @click="handleBack">返回</el-button>
    </div>
  </div>
</template>

<script>
import config from '../config'
import detailBaseInfo from '../components/detailBaseInfo.vue'
// eslint-disable-next-line import/no-cycle
import { collaborationDetail } from '../services'

export default {
  name: 'maintenanceReview_detail',
  components: {
    detailBaseInfo,
  },
  data() {
    const {
      maintenanceReviewDetailcolumn,
      maintenanceReviewdetailExamineInfo,
    } = config.call(this)
    return {
      baseInfo: {
        fileUrls: [],
      },
      examineInfo: {},
      baseInfoList: maintenanceReviewDetailcolumn,
      examineList: maintenanceReviewdetailExamineInfo,
    }
  },
  methods: {
    handleBack() {
      this.$refreshBack()
    },
    async getcollaborationDetail(id) {
      const { serviceTypes, auditStates } = config.call(this)
      const { code, data } = await collaborationDetail({ id })
      if (code === 1 && data) {
        this.baseInfo = data.serviceProviderDetail || {}
        try {
          const businessLicenceUrl = JSON.parse(
            this.baseInfo.businessLicenceUrl,
          )
          if (Array.isArray(businessLicenceUrl)) {
            this.baseInfo.businessLicenceUrl = businessLicenceUrl[0] || ''
          }
        } catch (e) {
          this.baseInfo.businessLicenceUrl = ''
        }

        try {
          if (Array.isArray(data.fileUrls)) {
            this.baseInfo.fileUrls = data.fileUrls || []
          } else {
            const fileUrlsList = JSON.parse(data.fileUrls)
            if (Array.isArray(fileUrlsList)) {
              this.baseInfo.fileUrls = fileUrlsList || []
            }
          }
        } catch (e) {
          this.baseInfo.fileUrls = []
        }

        this.baseInfo.serviceType =
          serviceTypes.get(this.baseInfo.serviceType) || ''

        this.examineInfo = {
          auditState: auditStates.get(data.auditState),
          auditTime: data.auditTime,
          auditRejectReason: data.auditRejectReason,
        }
      }
    },
  },
  created() {
    const { id } = this.$route.query
    this.getcollaborationDetail(id)
  },
}
</script>

<style lang="scss" scoped>
.details{
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.btns {
  text-align: center;
  position: sticky;
  bottom: 0;
}
.column-title {
  width: max-content !important;
  flex-shrink: 0 !important;
}
</style>
